<script lang="ts" setup>
import { t } from '@shared/i18n';
// @ts-ignore
import animatedChat from '@jaaluu/assets/videos/animated_chat.mp4';
import correctEmail from '@jaaluu/assets/videos/correct_email.mp4';
import emailWriting from '@jaaluu/assets/videos/email_writing.mp4';
import favStar from '@jaaluu/assets/videos/fav_star.mp4';
import favorite from '@jaaluu/assets/videos/favorite.mp4';
import helloGlobe from '@jaaluu/assets/videos/hello_globe.mp4';

import teaserVideoOverviewEn from '@jaaluu/assets/videos/jaaluu_overview_en.mp4';
import teaserVideoOverviewDe from '@jaaluu/assets/videos/jaaluu_overview_de.mp4';
import teaserVideoOverviewFr from '@jaaluu/assets/videos/jaaluu_overview_fr.mp4';
import teaserVideoOverviewEs from '@jaaluu/assets/videos/jaaluu_overview_es.mp4';
import teaserVideoOverviewRu from '@jaaluu/assets/videos/jaaluu_overview_ru.mp4';
import teaserVideoOverviewPt from '@jaaluu/assets/videos/jaaluu_overview_pt.mp4';
import teaserVideoOverviewIt from '@jaaluu/assets/videos/jaaluu_overview_it.mp4';
import teaserVideoOverviewPl from '@jaaluu/assets/videos/jaaluu_overview_pl.mp4';

import teaserVideoChatbotEn from '@jaaluu/assets/videos/jaaluu_chatbot_en.mp4';
import teaserVideoChatbotDe from '@jaaluu/assets/videos/jaaluu_chatbot_de.mp4';
import teaserVideoChatbotFr from '@jaaluu/assets/videos/jaaluu_chatbot_fr.mp4';
import teaserVideoChatbotEs from '@jaaluu/assets/videos/jaaluu_chatbot_es.mp4';
import teaserVideoChatbotRu from '@jaaluu/assets/videos/jaaluu_chatbot_ru.mp4';
import teaserVideoChatbotPt from '@jaaluu/assets/videos/jaaluu_chatbot_pt.mp4';
import teaserVideoChatbotIt from '@jaaluu/assets/videos/jaaluu_chatbot_it.mp4';
import teaserVideoChatbotPl from '@jaaluu/assets/videos/jaaluu_chatbot_pl.mp4';


import teaserVideoMainEn from '@jaaluu/assets/videos/jaaluu_main_en.mp4';
import teaserVideoMainDe from '@jaaluu/assets/videos/jaaluu_main_de.mp4';
import teaserVideoMainFr from '@jaaluu/assets/videos/jaaluu_main_fr.mp4';
import teaserVideoMainEs from '@jaaluu/assets/videos/jaaluu_main_es.mp4';
import teaserVideoMainRu from '@jaaluu/assets/videos/jaaluu_main_ru.mp4';
import teaserVideoMainPt from '@jaaluu/assets/videos/jaaluu_main_pt.mp4';
import teaserVideoMainIt from '@jaaluu/assets/videos/jaaluu_main_it.mp4';
import teaserVideoMainPl from '@jaaluu/assets/videos/jaaluu_main_pl.mp4';

import teaserVideoPhrasesEn from '@jaaluu/assets/videos/jaaluu_phrases_en.mp4';
import teaserVideoPhrasesDe from '@jaaluu/assets/videos/jaaluu_phrases_de.mp4';
import teaserVideoPhrasesFr from '@jaaluu/assets/videos/jaaluu_phrases_fr.mp4';
import teaserVideoPhrasesEs from '@jaaluu/assets/videos/jaaluu_phrases_es.mp4';
import teaserVideoPhrasesRu from '@jaaluu/assets/videos/jaaluu_phrases_ru.mp4';
import teaserVideoPhrasesPt from '@jaaluu/assets/videos/jaaluu_phrases_pt.mp4';
import teaserVideoPhrasesIt from '@jaaluu/assets/videos/jaaluu_phrases_it.mp4';
import teaserVideoPhrasesPl from '@jaaluu/assets/videos/jaaluu_phrases_pl.mp4';

import teaserVideoSrsEn from '@jaaluu/assets/videos/jaaluu_srs_en.mp4';
import teaserVideoSrsDe from '@jaaluu/assets/videos/jaaluu_srs_de.mp4';
import teaserVideoSrsFr from '@jaaluu/assets/videos/jaaluu_srs_fr.mp4';
import teaserVideoSrsEs from '@jaaluu/assets/videos/jaaluu_srs_es.mp4';
import teaserVideoSrsRu from '@jaaluu/assets/videos/jaaluu_srs_ru.mp4';
import teaserVideoSrsPt from '@jaaluu/assets/videos/jaaluu_srs_pt.mp4';
import teaserVideoSrsIt from '@jaaluu/assets/videos/jaaluu_srs_it.mp4';
import teaserVideoSrsPl from '@jaaluu/assets/videos/jaaluu_srs_pl.mp4';

import langLetters from '@jaaluu/assets/videos/lang_letters.mp4';
import level from '@jaaluu/assets/videos/level.mp4';
import listeningHeadphone from '@jaaluu/assets/videos/listening_headphones.mp4';
import network from '@jaaluu/assets/videos/network.mp4';
import specialVocab from '@jaaluu/assets/videos/special_vocab.mp4';
import srsSystem from '@jaaluu/assets/videos/srs_system.mp4';
import train from '@jaaluu/assets/videos/train.mp4';
import virtualLib from '@jaaluu/assets/videos/virtual_lib.mp4';
import SelectLanguages from '@jaaluu/components/Settings/SelectLanguages.vue';
import { GAnalyticsEvent } from '@jaaluu/interfaces/GAnalyticEvent';
import stores from '@jaaluu/stores';
import IconWithText from '@jaaluu/views/Welcome/IconWithText.vue';
import MovingVideosWithText from '@jaaluu/views/Welcome/MovingVideosWithText.vue';
import VideoTextCols from '@jaaluu/views/Welcome/VideoTextCols.vue';
import VideoWithText from '@jaaluu/views/Welcome/VideoWithText.vue';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import LogoBalls from './LogoBalls.vue';
import { onMounted } from 'vue';
import {
  LANDING_GROUPS,
  LANDING_GROUP_TITLES,
  LANDING_PAGE_PATHS,
  OG_LOCALE,
  setCanonical,
  setHreflangAlternates,
  setJsonLd,
  setMetaDescription,
  setOgTags,
  setRobotsMeta,
  urlFor,
  type CourseLang,
  type LandingLang
} from '@jaaluu/composables/useLandingSeo';
import { getLangSubdomain, SUPPORTED_SUBDOMAIN_LANGS } from '@jaaluu/utils/subdomain';
import welcomeSeoContent from '@jaaluu/data/welcomeSeoContent.json';
import type { Language } from '@shared/openapi/jaaluu-api/types.gen';

const BASE_URL_APP = (import.meta as any).env.VITE_JAALUU_URL;
const router = useRouter();
const route = useRoute();
const { sendEvent, sendConversionStartLearning } = stores.gAnalytics.funcs;
const { logoWideBlackSmall } = stores.assets.state;
const { langNative, langForeign, langOptions } = stores.language.state;

const selectedTeaserVideo = ref('main');
const teaserVideos: any = {
  main: {
    en: teaserVideoMainEn,
    de: teaserVideoMainDe,
    fr: teaserVideoMainFr,
    es: teaserVideoMainEs,
    ru: teaserVideoMainRu,
    pt: teaserVideoMainPt,
    it: teaserVideoMainIt,
    pl: teaserVideoMainPl,
  },
  overview: {
    en: teaserVideoOverviewEn,
    de: teaserVideoOverviewDe,
    fr: teaserVideoOverviewFr,
    es: teaserVideoOverviewEs,
    ru: teaserVideoOverviewRu,
    pt: teaserVideoOverviewPt,
    it: teaserVideoOverviewIt,
    pl: teaserVideoOverviewPl,
  },
  phrases: {
    en: teaserVideoPhrasesEn,
    de: teaserVideoPhrasesDe,
    fr: teaserVideoPhrasesFr,
    es: teaserVideoPhrasesEs,
    ru: teaserVideoPhrasesRu,
    pt: teaserVideoPhrasesPt,
    it: teaserVideoPhrasesIt,
    pl: teaserVideoPhrasesPl,
  },
  chatbot: {
    en: teaserVideoChatbotEn,
    de: teaserVideoChatbotDe,
    fr: teaserVideoChatbotFr,
    es: teaserVideoChatbotEs,
    ru: teaserVideoChatbotRu,
    pt: teaserVideoChatbotPt,
    it: teaserVideoChatbotIt,
    pl: teaserVideoChatbotPl,
  },
  srs: {
    en: teaserVideoSrsEn,
    de: teaserVideoSrsDe,
    fr: teaserVideoSrsFr,
    es: teaserVideoSrsEs,
    ru: teaserVideoSrsRu,
    pt: teaserVideoSrsPt,
    it: teaserVideoSrsIt,
    pl: teaserVideoSrsPl,
  },
};

const TARGET_LANG_CODES: CourseLang[] = ['de', 'en', 'es', 'fr', 'it', 'pt', 'ru', 'pl', 'zh'];

onMounted(() => {
  const campaign = route.params.campaign;
  if (campaign) {
    selectedTeaserVideo.value = campaign.toString();
  }

  // Spoke landing pages (e.g. "sprachzeitung-englisch") link here with
  // ?target=<code> so "learn Spanish" traffic doesn't land on a blank
  // language picker - preselect the foreign-language dropdown when present.
  // langOptions/supportedLangs may still be loading at this point (see
  // Main.vue), but langForeign itself just needs a valid Language code, the
  // same direct assignment Main.vue already uses for the :langForeign route
  // param.
  const target = route.query.target?.toString();
  if (target && (TARGET_LANG_CODES as string[]).includes(target)) {
    langForeign.value = target as Language;
  }

  const subdomain = getLangSubdomain();
  if (subdomain) {
    setRobotsMeta('index, follow');
    const seoEntry = (welcomeSeoContent as Record<string, { title: string; description: string }>)[
      subdomain
    ];
    if (seoEntry) {
      document.title = seoEntry.title;
      setMetaDescription(seoEntry.description);
      setOgTags({
        title: seoEntry.title,
        description: seoEntry.description,
        url: urlFor(subdomain, 'welcome'),
        image: urlFor(subdomain, 'og-image.png'),
        locale: OG_LOCALE[subdomain as LandingLang]
      });
      setJsonLd([
        {
          '@type': 'Organization',
          '@id': 'https://jaaluu.com/#organization',
          name: 'Jaaluu',
          url: 'https://jaaluu.com'
        },
        {
          '@type': 'SoftwareApplication',
          name: 'Jaaluu',
          description: seoEntry.description,
          url: urlFor(subdomain, 'welcome'),
          applicationCategory: 'EducationalApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' }
        }
      ]);
    }
    setCanonical(urlFor(subdomain, 'welcome'));
    setHreflangAlternates([
      ...SUPPORTED_SUBDOMAIN_LANGS.map((lang) => ({
        hreflang: lang,
        href: urlFor(lang, 'welcome')
      })),
      { hreflang: 'x-default', href: urlFor('en', 'welcome') }
    ]);
  }
})

const localLandingLinks = computed(() => {
  const subdomain = getLangSubdomain() as LandingLang | undefined;
  if (!subdomain) return [];
  return LANDING_GROUPS.map((group) => {
    const path = LANDING_PAGE_PATHS[group][subdomain];
    const title = LANDING_GROUP_TITLES[group][subdomain];
    return path && title ? { path: `/${path}`, title } : null;
  }).filter((link): link is { path: string; title: string } => !!link);
});

const navigateTo = (navTo: string) => {
  if (!langForeign.value || !langNative.value) {
    console.error('no langForeign or langNative');
  }
  router.push(navTo);
};

const scrollTo = (elId: string) => {
  const el = document.querySelector(elId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};

const atSelectLangAndStart = () => {
  scrollTo('#select-langs');
  sendEvent(GAnalyticsEvent.CLICK_SELECT_LANG_AND_START);
};

const atStartLearning = () => {
  sendEvent(GAnalyticsEvent.CLICK_START_LEARNING);
  sendConversionStartLearning();
  navigateTo('/intro');
};
</script>

<template>
  <div class="mx-auto relative w-full no-overflow">
    <div class="d-flex justify-center flex-column align-center mx-auto bg-green app-bar">
      <v-img
        transition="scale-transition"
        alt="Jaaluu"
        class="mt-1 cursor-pointer mr-2"
        contain
        min-width="175"
        :src="logoWideBlackSmall"
        width="55"
      />
    </div>
    <div class="d-flex flex-column align-center"></div>
    <div>
      <slot></slot>
    </div>

    <VideoWithText
      :title="t('welcome.hero_headline')"
      :text="''"
      :videoSrc="langLetters"
      heading-tag="h1"
    >
    <!-- <div>{{ t('welcome.hero_subheadline') }}</div> -->
      <v-btn small class="mt-2" color="green" @click="() => atSelectLangAndStart()">
        {{ t('welcome.hero_cta') }}
      </v-btn>
    </VideoWithText>

    <div class="mt-8 pt-12 max-width-small mx-auto" id="select-langs">
      <SelectLanguages :from-welcome="true" />
      <div class="d-flex flex-column">
        <v-btn
          small
          class="mt-8"
          color="green"
          @click="() => atStartLearning()"
          :disabled="!langForeign"
        >
          {{ t('welcome.start_learning') }}
        </v-btn>

        <!-- <v-btn variant="text" small class="mt-4" color="green" @click="scrollTo('#how-to')">
          {{ t('welcome.how_does_this_work') }}
        </v-btn> -->
      </div>
    </div>
    <!-- <div class="bg-green pt-4 pb-8 mt-12" id="how-to">
      <v-tabs class="mb-2" v-model="selectedTeaserVideo" align-tabs="center" color="white">
        <v-tab :value="'main'">Welcome</v-tab>
        <v-tab :value="'overview'">Overview</v-tab>
        <v-tab :value="'phrases'">Phrases</v-tab>
        <v-tab :value="'chatbot'">Chatbot</v-tab>
        <v-tab :value="'srs'">Train</v-tab>
      </v-tabs>
      <v-tabs-window v-model="selectedTeaserVideo">
        <v-tabs-window-item v-for="key in Object.keys(teaserVideos)" :key="key" :value="key">
          <div class="d-flex justify-center">
            <video controls muted playsinline autoplay loop class="video" v-if="langNative">
              <source :src="teaserVideos[key][langNative]" type="video/mp4" />
            </video>
          </div>
        </v-tabs-window-item>
      </v-tabs-window>
    </div>-->

    <VideoWithText
      :title="t('welcome.how_to_title')"
      :text="t('welcome.how_to_text')"
      :videoSrc="virtualLib"
      :video-first="false"
    >
      <div class="relative mt-5" :style="{ height: '50px' }">
        <LogoBalls />
      </div>
    </VideoWithText>


    <VideoWithText
      :title="t('welcome.listen_title')"
      :text="t('welcome.listen_text')"
      :videoSrc="listeningHeadphone"
      :animate="true"
    >
      <v-btn size="x-small" variant="text" class="mt-2" color="green" @click="scrollTo('#listen')">
        {{ t('general.more') }}
      </v-btn>
    </VideoWithText>
    <VideoWithText
      :title="t('welcome.conversations_title')"
      :text="t('welcome.conversations_text')"
      :videoSrc="animatedChat"
      :video-first="false"
      :animate="true"
    >
      <v-btn
        size="x-small"
        variant="text"
        class="mt-2"
        color="green"
        @click="scrollTo('#conversations')"
      >
        {{ t('general.more') }}
      </v-btn>
    </VideoWithText>

    <MovingVideosWithText
      :title="t('welcome.writing_title')"
      :contents="[
        { video: emailWriting, text: t('welcome.writing_text_1') },
        {
          video: correctEmail,
          text: t('welcome.writing_text_2')
        }
      ]"
      ><v-btn
        size="x-small"
        variant="text"
        class="mt-2"
        color="green"
        @click="scrollTo('#writing')"
      >
        {{ t('general.more') }}
      </v-btn>
    </MovingVideosWithText>

    <VideoWithText
      :title="t('welcome.texts_and_videos_title')"
      :text="t('welcome.texts_and_videos_text')"
      :videoSrc="level"
      :video-first="false"
    >
      <v-btn
        size="x-small"
        variant="text"
        class="mt-2"
        color="green"
        @click="scrollTo('#texts-and-video')"
      >
        {{ t('general.more') }}
      </v-btn>
    </VideoWithText>

    <VideoTextCols
      :title="t('welcome.srs_title')"
      :contents="[
        {
          video: favorite,
          text: t('welcome.srs_text_1')
        },
        {
          video: train,
          text: t('welcome.srs_text_2')
        },
        {
          video: srsSystem,
          text: t('welcome.srs_text_3')
        }
      ]"
      :animate="true"
    >
      <v-btn size="x-small" variant="text" class="mt-2" color="green" @click="scrollTo('#srs')">
        {{ t('general.more') }}
      </v-btn>
    </VideoTextCols>

    <VideoWithText
      :title="t('welcome.own_text_title')"
      :text="t('welcome.own_text_text')"
      :videoSrc="specialVocab"
      :video-first="false"
    >
      <v-btn
        size="x-small"
        variant="text"
        class="mt-2"
        color="green"
        @click="scrollTo('#own-text')"
      >
        {{ t('general.more') }}
      </v-btn>
    </VideoWithText>

    <MovingVideosWithText
      :title="t('welcome.wordmap_title')"
      :contents="[
        {
          video: network,
          text: t('welcome.wordmap_text_1')
        },
        {
          video: favStar,
          text: t('welcome.wordmap_text_2')
        }
      ]"
      :video-class="'scale-down'"
    >
      <v-btn size="x-small" variant="text" class="mt-2" color="green" @click="scrollTo('#wordmap')">
        {{ t('general.more') }}
      </v-btn>
    </MovingVideosWithText>

    <VideoWithText
      :title="t('welcome.sayings_title')"
      :text="t('welcome.sayings_text')"
      :videoSrc="helloGlobe"
      :video-first="false"
    />

    <div class="d-flex justify-center py-3 mt-12">
      <v-btn small class="" color="green" @click="scrollTo('#select-langs')">
        {{ t('welcome.select_language_and_start') }}
      </v-btn>
    </div>

    <div class="welcome-content-width mx-auto mt-16">
      <h2 class="text-center title-welcome mb-n8">{{ t('welcome.details') }}</h2>
      <IconWithText
        id="texts-and-video"
        :title="t('welcome.details_text_and_videos_title')"
        :text="t('welcome.details_text_and_videos_text')"
        icon="mdi-text-long"
      />

      <IconWithText
        id="click-on-words"
        :title="t('welcome.details_click_on_words_title')"
        :text="t('welcome.details_click_on_words_text')"
        icon="mdi-file-word-box-outline"
      />

      <IconWithText
        id="listen"
        :title="t('welcome.details_listen_title')"
        :text="t('welcome.details_listen_text')"
        icon="mdi-headphones"
      />

      <IconWithText
        id="conversations"
        :title="t('welcome.details_conversations_title')"
        :text="t('welcome.details_conversations_text')"
        icon="mdi-message"
      />

      <IconWithText
        id="writing"
        :title="t('welcome.details_writing_title')"
        :text="t('welcome.details_writing_text')"
        icon="mdi-receipt-text-edit-outline"
      />

      <IconWithText
        id="srs"
        :title="t('welcome.details_srs_title')"
        :text="t('welcome.details_srs_text')"
        icon="mdi-brain"
      />

      <IconWithText
        id="own-text"
        :title="t('welcome.details_own_text_title')"
        :text="t('welcome.details_own_text_text')"
        icon="mdi-star-four-points-outline"
      />

      <IconWithText
        id="wordmap"
        :title="t('welcome.details_wordmap_title')"
        :text="t('welcome.details_wordmap_text')"
        icon="mdi-transit-connection-horizontal"
      />

      <IconWithText
        id="paste-text"
        :title="t('welcome.details_paste_text_title')"
        :text="t('welcome.details_paste_text_text')"
        icon="mdi-content-copy"
      />
      <IconWithText
        id="paste-text"
        :title="t('welcome.which_languages_title')"
        :text="t('welcome.which_languages_text')"
        icon="mdi-translate"
      />
    </div>

    <div class="d-flex justify-center py-3">
      <v-btn small class="" color="green" @click="scrollTo('#select-langs')">
        {{ t('welcome.select_language_and_start') }}
      </v-btn>
    </div>

    <div class="relative bg-gradient mt-12" :style="{ height: '100px' }">
      <LogoBalls />
    </div>
    <div class="bg-green pt-8 pb-8 text-black" v-if="localLandingLinks.length">
      <div class="welcome-content-width mx-auto">
        <div class="d-flex justify-center mb-4">{{ t('welcome.explore_more') }}:</div>
        <div class="d-flex flex-wrap justify-center align-center">
          <router-link
            v-for="link in localLandingLinks"
            :key="link.path"
            :to="link.path"
            class="mr-8 mt-2 explore-link"
          >
            {{ link.title }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="bg-green pt-8 pb-8 text-black">
      <div class="welcome-content-width mx-auto">
        <div class="d-flex justify-center mb-4">{{ t('welcome.site_also_available') }}:</div>
        <div class="d-flex flex-wrap justify-center align-center">
          <div v-for="langOpt in langOptions" class="mr-12 mt-4 d-flex align-center">
            <a :href="`${BASE_URL_APP.replace('//', `//${langOpt.value}.`)}/welcome`"
              ><img :src="langOpt.flag" :alt="langOpt.title" class="flag-icon mr-2" /><span>{{
                langOpt.title
              }}</span></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.max-width-small {
  max-width: 300px;
}

.flag-icon {
  width: 25px;
}
.explore-link {
  color: inherit;
  text-decoration: none;
  font-weight: 600;
}
.explore-link:hover {
  text-decoration: underline;
}
.transition {
  transition: width 1s ease;
}
.bg-footer {
  background: rgb(var(--v-theme-on-surface));
}
.bg-green {
  background: #4caf50;
  color: white;
}
.app-bar {
  height: 65px;
  padding-bottom: 10px;
}
.bg-gradient {
  background: linear-gradient(white, #4caf50);
}
.flag-icon {
  width: 25px;
}
.no-overflow {
  overflow: hidden;
}
video {
  width: 100%;
  filter: grayscale(0);
}
@media screen and (min-width: 800px) {
  video {
    width: 50%;
    filter: grayscale(0);
  }
}
</style>
